import { NetworkRequestState } from '../baseTypes';
import { BlockedUsernamesWidgetData } from './types';

const defaultBlockedUsernamesWidgetData: NonNullable<
  BlockedUsernamesWidgetData['initialData']
> = {
  blockedUsers: [],
};

export const defaultBlockedUsernamesWidgetState: BlockedUsernamesWidgetData = {
  initialData: defaultBlockedUsernamesWidgetData,
  currentData: defaultBlockedUsernamesWidgetData,
  isDirty: false,
  saveRequest: {
    status: NetworkRequestState.IDLE,
  },
};
